import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import styles from "./Customtab.module.css";

const CustomTab = ({
  tabs = [],
  value,
  onChange,
  className = "",
  variant = "standard",
  ...rest
}) => {
  return (
    <Tabs
      value={value}
      onChange={(e, newValue) => onChange && onChange(newValue)}
      variant={variant}
      className={`${styles.tabs} ${className}`}
      TabIndicatorProps={{ className: styles.indicator }}
      {...rest}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.label}
          icon={tab.icon}
          iconPosition="start"
          disabled={tab.disabled}
          className={styles.tab}
        />
      ))}
    </Tabs>
  );
};

export default CustomTab;
